module.exports = __webpack_public_path__ + "work_team.ecd57b41ebc1cdff9b9b3c0f5208c307.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/users/work_team.png
// module id = 8403855022645337
// module chunks = 1